import { makeStyles } from 'tss-react/mui';


export const useSettingsStyles = makeStyles()((theme) => ({
  sectionEditButton: {
    marginTop: theme.spacing(-1),
    marginBottom: theme.spacing(-1),
  },
  semiBold: {
    fontWeight: 500
  },
  capitalize: {
    textTransform: 'capitalize'
  },
  link: {
    fontFamily: 'inherit',
    verticalAlign: 'baseline'
  },
  insuranceHeader: {
    background: theme.palette.grey[50],
    zIndex: 1,
    paddingTop: theme.spacing(1),
    marginTop: theme.spacing(-1)
  },
  paperWidthMd: {
    maxWidth: '600px'
  },
  divider: {
    display: 'flex',
    width: '100%',
  },
  valueTypography: {
    marginTop: theme.spacing(0.5),
  },
  marginBottomTypography: {
    marginBottom: theme.spacing(2),
  },
  actions: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
  },
  fixedContainer: {
    position: 'fixed',
    right: 0,
    bottom: 0,
    left: 0,
    padding: theme.spacing(2),
    background: theme.palette.background.paper,
    boxShadow: `inset 0 1px 0 ${theme.palette.divider}`,
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
    zIndex: theme.zIndex.appBar
  },
  buttonContainer: {
    display: 'flex',
    gap: theme.spacing(1),
    '& > button': {
      flex: 1,
    }
  },
  mobileModalActions: {
    display: 'flex',
    justifyContent: 'center',
    gap: theme.spacing(1),
    flexDirection: 'column-reverse',
    '& *': {
      marginLeft: '0 !important',
    }
  },
  mobileModalContent: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    '& > :first-child': {
      display: 'flex',
      flexDirection: 'column',
    }
  },
  modalContent: {
    display: 'flex',
    gap: theme.spacing(1),
  },
  alert: {
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    maxWidth: '486px',
    width: 'calc(100% - 64px)',
    [theme.breakpoints.down('sm')]: {
      width: 'initial'
    }
  },
  phoneBlock: {
    display: 'flex',
    flexDirection: 'column',
    '& > *:not(:last-child)': {
      paddingBottom: theme.spacing(2)
    },
  },

}));
